export type RecoveryStep =
  | { action: "retry-same-worker"; delayMs: number }
  | { action: "recreate-worker"; delayMs: number }
  | { action: "offer-choice" }
  | { action: "give-up" };

export function nextRecoveryStep(attempt: number): RecoveryStep {
  if (attempt === 0) return { action: "retry-same-worker", delayMs: 8_000 };
  if (attempt === 1) return { action: "recreate-worker", delayMs: 1_500 };
  if (attempt === 2) return { action: "offer-choice" };
  return { action: "give-up" };
}
